import { z } from 'zod';

const facilitySearchTermSchema = z.looseObject({
  emboldId: z.string(),
  searchTerm: z.string(),
});

const providerSearchTermSchema = z.looseObject({
  searchTerm: z.string(),
  specialtyId: z.number(),
  specialtyName: z.string(),
  subspecialtyId: z.number().nullable(),
  subspecialtyName: z.string().nullable(),
});

export const searchTermResponseSchema = z.looseObject({
  facility: z.array(facilitySearchTermSchema),
  provider: z.array(providerSearchTermSchema),
});

export type ProviderSearchTerm = z.infer<typeof providerSearchTermSchema>;
export type FacilitySearchTerm = z.infer<typeof facilitySearchTermSchema>;
export type SearchTermResponse = z.infer<typeof searchTermResponseSchema>;
